namespace Matrix.Rebalancer {
    export class SummaryViewColumnColumns {
        static columnsKey = 'Rebalancer.SummaryViewColumn';
    }
}
